const DEFAULT_GROUP_PRECISION = 6;
const DEFAULT_SPIDERFY_RADIUS = 0.0002;

const groupMarkersByLocation = (markers, precision = DEFAULT_GROUP_PRECISION) => {
  const locationGroups = new Map();

  (markers || []).forEach(marker => {
    if (!marker?.location) {
      return;
    }

    const { lat, lng } = marker.location;
    if (!isFinite(lat) || !isFinite(lng)) {
      return;
    }

    const key = `${lat.toFixed(precision)},${lng.toFixed(precision)}`;
    const group = locationGroups.get(key) || [];
    group.push(marker);
    locationGroups.set(key, group);
  });

  return locationGroups;
};

export const spiderfyMarkers = (markers, options = {}) => {
  const precision = options.precision ?? DEFAULT_GROUP_PRECISION;
  const radius = options.radius ?? DEFAULT_SPIDERFY_RADIUS;
  const locationGroups = groupMarkersByLocation(markers, precision);
  const spiderfiedMarkers = [];

  locationGroups.forEach(group => {
    if (group.length === 1) {
      spiderfiedMarkers.push(group[0]);
      return;
    }

    const angleStep = (2 * Math.PI) / group.length;

    group.forEach((marker, index) => {
      const angle = angleStep * index;
      const offsetLat = radius * Math.cos(angle);
      const offsetLng = radius * Math.sin(angle);

      spiderfiedMarkers.push({
        ...marker,
        location: {
          lat: marker.location.lat + offsetLat,
          lng: marker.location.lng + offsetLng,
        },
        originalLocation: {
          lat: marker.location.lat,
          lng: marker.location.lng,
        },
        isSpiderfied: true,
      });
    });
  });

  return spiderfiedMarkers;
};

export const getSpiderfiedCenters = (markers, precision = DEFAULT_GROUP_PRECISION) => {
  const centers = new Map();

  (markers || []).forEach(marker => {
    if (!marker?.originalLocation) {
      return;
    }

    const { lat, lng } = marker.originalLocation;
    if (!isFinite(lat) || !isFinite(lng)) {
      return;
    }

    const key = `${lat.toFixed(precision)},${lng.toFixed(precision)}`;
    if (!centers.has(key)) {
      centers.set(key, marker.originalLocation);
    }
  });

  return Array.from(centers.values());
};